export enum ResetScreens {
  EMAIL_SCREEN = 1,
  RESET_PASSWORD_SCREEN = 2,
}

export const MAX_RETRY_CODE = 429;

export enum ResetPasswordErrors {
  CODE_EXPIRED = 'FP-0001',
  CODE_INVALID = 'FP-0002',
}

export const passwordValidators = [
  {
    label: 'Not have any white spaces',
    pattern: /^\S+$/,
    noOfCharactersRequiredForValidation: 0,
  },
  {
    label: 'Be a minimum of 10 characters',
    pattern: /^.{10,}$/,
    noOfCharactersRequiredForValidation: 0,
  },
  {
    label: 'Include at least one number',
    pattern: /[0-9]/,
    noOfCharactersRequiredForValidation: 0,
  },
  {
    label: 'Include at least one lowercase character',
    pattern: /[a-z]/,
    noOfCharactersRequiredForValidation: 0,
  },
  {
    label: 'Include at least one uppercase character',
    pattern: /[A-Z]/,
    noOfCharactersRequiredForValidation: 0,
  },
  {
    label: 'Include at least one special character',
    pattern: /[!@#$%^&*()_+[\]{};':"\\|,.<>?/~`-]/,
    noOfCharactersRequiredForValidation: 0,
  },
];
